export default __webpack_public_path__ + "243a682b34b4d1f3365398aa3c2b940f.svg";